// extracted by mini-css-extract-plugin
export default {"preview":"Preview_preview__x80ZR","OpacityTransition":"Preview_OpacityTransition__WW7da","group":"Preview_group__HcmuO"};